import { useLocale } from "@babackapp/translations/use-set-locale";
import { useEffect } from "react";
import { useAuth } from "@babackapp/auth-client/context";


export const useLoggedViewer = () => {
  const [, setLocale] = useLocale();
  const { user } = useAuth();


  useEffect(() => {
    setLocale(user?.profile?.lang);
  }, [user?.profile?.lang]);

  return {
    data: user,
  };
};
